// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import uploader from 'vue-simple-uploader'
Vue.use(uploader)
import router from './router'
import depot from './http/index.js'
// 引入icon图标库
import iconPicker from 'e-icon-picker';
import "e-icon-picker/lib/symbol.js"; //基本彩色图标库
import 'e-icon-picker/lib/index.css'; // 基本样式，包含基本图标
import 'font-awesome/css/font-awesome.min.css'; //font-awesome 图标库
import 'element-ui/lib/theme-chalk/icon.css'; //element-ui 图标库
Vue.use(iconPicker, { eIcon: true, ElementUI: true, FontAwesome: true, eIconSymbol: true });
// 引入axios
import axios from "axios";
Vue.prototype.$http = axios;
Vue.config.productionTip = false
//全局变量
import global_ from './Base.vue'
Vue.prototype.GLOBAL = global_;
axios.defaults.baseURL=global_.BASE_URL;
axios.defaults.UPLOAD_URL=global_.UPLOAD_URL;
axios.defaults.WEBSOCKET_URL=global_.WEBSOCKET_URL;
Vue.use(iconPicker, { eIcon: true, ElementUI: true, FontAwesome: true, eIconSymbol: true });
// 引入地区选择器
import VueAreaLinkage from 'vue-area-linkage';

import 'vue-area-linkage/dist/index.css'; 

Vue.use(VueAreaLinkage);
// 引入element Ui
import ElementUI from 'element-ui'
Vue.prototype.http = axios;
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
//引入video.js
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video


depot()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js